import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { SelectItem } from '../../widgets/SelectItem';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';

const utils = new ViewUtils();

function hasSelection(value) {
    return !utils.isNull(value) && !utils.isNull(value.Id);
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
    MuiSelectSelectMenu: {
        '& .MuiSelect-selectMenu': { paddingRight: "150px !important" }
    }
}));

export default function DGDocumentsUploadSearchForm(props) {
    const [labelWidth, setLabelWidth, tabValue] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);

    return (
        <EntityForm viewId="organisation" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            dataURL={utils.isNull(props.dataURL) ? "" : props.dataURL}
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={classes.container} >
                    <table cellPadding="2">
                        <tbody>
                            <tr>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/dgdocumentupload/GetDGFinancialYearLookupList"
                                            id="FinancialYearID"
                                            key={tabValue}
                                            label="Financial Year"
                                            className={classes.MuiSelectSelectMenu}
                                            required={true}
                                            form={form}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/dgdocumentupload/GetLookupListDiscretionaryGrantType?parameter="
                                            id="DGTypeID"
                                            label="Window Type"
                                            className={classes.MuiSelectSelectMenu}
                                            required={true}
                                            form={form}
                                            hasDependency={true}
                                            dependency={props.windowTypeDependency}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/dgdocumentupload/GetLookupListDiscretionaryGrantIntervention?parameter="
                                            id="DGInterventionID"
                                            label="Intervention Type"
                                            className={classes.MuiSelectSelectMenu}
                                            required={true}
                                            form={form}
                                            hasDependency={true}
                                            dependency={props.interventionDependency}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/dgdocumentupload/GetLookupList?listid=DGDocumentType"
                                            id="DocumentType"
                                            label="Document Type"
                                            className={classes.MuiSelectSelectMenu}
                                            required={true}
                                            form={form}
                                            disabled={utils.isNull(props.interventionDependency) || !hasSelection(form.values.DGInterventionID)}
                                        />
                                    </FormControl>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form >
            }
        </EntityForm>
    );
}
